// extracted by mini-css-extract-plugin
module.exports = {"statuses":"ComplaintsStatusFlow_statuses__3jXXs","status":"ComplaintsStatusFlow_status__32RLS"};